import { render, staticRenderFns } from "./topTip.vue?vue&type=template&id=c46e1af2&scoped=true"
import script from "./topTip.vue?vue&type=script&lang=js"
export * from "./topTip.vue?vue&type=script&lang=js"
import style0 from "./topTip.vue?vue&type=style&index=0&id=c46e1af2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46e1af2",
  null
  
)

export default component.exports